module.exports = __webpack_public_path__ + "static/img/2.20af907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/2.png
// module id = ne6D
// module chunks = 0